<template>
  <hm-content title>
    <div class>
      <!-- <div class="mb20">
        <el-radio-group v-model="ruleMode" size="small" @change="switchTab">
          <el-radio-button label="integral">积分</el-radio-button>
          <el-radio-button label="growth">成长值</el-radio-button>
        </el-radio-group>
      </div> -->
      <div class="rule-list flex flex-wrap">
        <div class="rule-item" v-for="(v, i) in list" :key="i">
          <div @click="changeRule(v)" class="pointer">
            <div class="rule-row flex">
              <span class="label">规则名称：</span>
              <div class="primary flex-1">{{ v.ruleName }}</div>
            </div>
            <div class="rule-row flex item-center">
              <span class="label">规则标签：</span>
              <div class="tags flex flex-wrap flex-1">
                <div
                  class="tag"
                  v-for="(item, index) in [v.ruleLabel]"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="rule-row flex">
              <span class="label">状态：</span>
              <div class="flex-1">
                <span class="gray" v-if="v.ruleState === 'enabled'"
                  >未启用</span
                >
                <span class="blue" v-if="v.ruleState === 'wait'">待审核</span>
                <span class="danger" v-if="v.ruleState === 'refuse'"
                  >已驳回</span
                >
                <span class="success" v-if="v.ruleState === 'agree'"
                  >已同意</span
                >
                <span class="success" v-if="v.ruleState === 'upLine'"
                  >上线</span
                >
                <span class="danger" v-if="v.ruleState === 'downLine'"
                  >下线</span
                >
              </div>
            </div>
          </div>
          <div class="rule-row flex flex-center">
            <el-button
              size="small"
              type="success"
              :disabled="
                v.ruleState === 'enabled' ||
                  v.ruleState === 'wait' ||
                  v.ruleState === 'refuse'
              "
              @click="online(v, 'upLine')"
              v-if="v.ruleState === 'agree' || v.ruleState === 'downLine'"
              >上线</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="offline(v)"
              v-if="v.ruleState === 'upLine'"
              >下线</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="规则编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="mb20">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="规则名称：">
            <el-input
              size="small"
              disabled
              v-model="ruleForm.ruleName"
            ></el-input>
          </el-form-item>
          <el-form-item label="规则编号：">
            <el-input
              size="small"
              disabled
              v-model="ruleForm.ruleSn"
            ></el-input>
          </el-form-item>
          <el-form-item label="规则标签：" prop="tag">
            <el-tag
              :key="i"
              v-for="(v, i) in ruleForm.tag"
              closable
              :disable-transitions="false"
              @close="handleClose(v)"
              >{{ v }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              :disabled="ruleForm.tag.length > 0"
              @click="showInput"
              >+新标签</el-button
            >
          </el-form-item>
          <el-form-item label="详细规则：" prop="integralAmount">
            <div class="flex way">
              <div class="way-item flex">
                <span>每消费</span>
                <div class="item">
                  <el-input
                    style="width:100px"
                    class="ipt"
                    clearable
                    size="small"
                    v-model="ruleForm.useLowerLimit"
                    @input="filterGt0OrFixed2('useLowerLimit')"
                  ></el-input
                  >元，
                </div>
              </div>
              <div class="way-item flex">
                <span>奖励</span>
                <div class="item">
                  <!-- <el-input
                    style="width:100px"
                    clearable
                    class="ipt"
                    v-model="ruleForm.awardValue"
                    @input="filterGt0OrFixed2('awardValue', 'removePoint')"
                    size="small"
                  ></el-input
                  > -->
                  1积分
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
      <div class="p20">
        <div class="title">操作日志</div>
      </div>
      <el-table
        stripe
        border
        :data="logs"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="beforeDataValue"
          label="操作前"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="afterDataValue"
          label="操作结果"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="operateName"
          label="操作人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="操作时间"
        >
        </el-table-column>
      </el-table>
      <!-- <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    const patternLocation = function(rule, val, callback) {
      if (!this.ruleForm.useLowerLimit) {
        return callback(new Error("消费金额不能为空"));
      }
      //   if (!this.ruleForm.awardValue) {
      //     return callback(new Error("奖励积分不能为空"));
      //   }
      callback();
    }.bind(this);
    const patternTag = function(rule, val, callback) {
      if (val.length !== 1) {
        return callback(new Error("请加规则标签!"));
      }
      callback();
    }.bind(this);
    return {
      inputVisible: false,
      inputValue: "",
      ruleForm: {
        id: "",
        ruleName: "",
        ruleSn: "",
        tag: [],
        useLowerLimit: "",
        awardValue: ""
      },
      rules: {
        integralAmount: [
          { required: true, validator: patternLocation, trigger: "blur" }
        ],
        tag: [{ required: true, validator: patternTag, trigger: "blur" }]
      },
      dialogVisible: false,
      ruleMode: "integral",
      list: [],
      logs: [],
      total: 0,
      row: {},
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      const { result } = await this.$store.dispatch("queryIntegralRuleList");

      this.list = result;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch(
        "queryIntegralRuleDetails",
        {
          id: this.row.id
        }
      );
      const { logList, rewardRule } = result;
      this.logs = logList;
      for (let key in this.ruleForm) {
        this.ruleForm[key] = rewardRule[key];
      }
      if (rewardRule.ruleLabel === "" || !rewardRule.ruleLabel) {
        this.ruleForm.tag = [];
      } else {
        this.ruleForm.tag = [];
        this.ruleForm.tag.push(rewardRule.ruleLabel);
      }
    },
    async queryLogList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ruleId: this.row.ruleId
      };

      const { result } = await this.$store.dispatch("queryFindLogList", params);
      const { records, total } = result;

      this.logs = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryLogList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryLogList();
    },
    switchTab() {
      this.queryList();
    },
    changeRule(v) {
      this.dialogVisible = true;
      this.row = v;
      this.queryDetails();
      // this.ruleForm = JSON.parse(JSON.stringify(v));
    },
    handleClose(v) {
      this.ruleForm.tag.splice(this.ruleForm.tag.indexOf(v), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop, type) {
      if (prop !== "useLowerLimit") {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
        // if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //   //首位是0的话去掉
        //   this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
        // }
      }
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数

      if (type === "removePoint") {
        if (String(this.ruleForm[prop]).indexOf(".") >= 0) {
          this.ruleForm[prop] = this.ruleForm[prop].replace(/\./g, "");
        }
      }
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.tag.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    async online(v, ruleState) {
      const params = JSON.parse(JSON.stringify(v));
      const { code } = await this.$store.dispatch("editIntegralRuleDetails", {
        id: params.id,
        ruleState
      });
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.queryList();
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        // if (this.ruleForm.ruleSn === "95811141149470") {
        //   let ruleDetail = {
        //     amount: this.ruleForm.redpacketMoney,
        //     award: this.ruleForm.integral
        //   };
        //   params.ruleDetail = JSON.stringify(ruleDetail);
        // } else if (this.ruleForm.ruleSn === "95824031940683") {
        //   let ruleDetail = {
        //     amount: this.ruleForm.redpacketMoney,
        //     award: this.ruleForm.integral
        //   };
        //   params.ruleDetail = JSON.stringify(ruleDetail);
        // }
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        params.ruleLabel = this.ruleForm.tag[0];
        params.awardValue = 1;
        this.$store.dispatch("editIntegralRuleDetails", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.dialogVisible = false;
            this.queryList();
          }
        });
      } else {
        return false;
      }
    },
    async offline(v) {
      const result = await this.$confirm(
        "确认下线" + v.ruleName + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      );
      if (result) {
        this.online(v, "downLine");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.rule-item {
  width: 324px;
  height: 207px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 36px 0px rgba(219, 219, 219, 0.5);
  border-radius: 5px;
  padding: 30px 21px;
  box-sizing: border-box;
  margin: 0 42px 42px 0;
  .rule-row {
    margin-bottom: 20px;
  }

  .label {
    width: 70px;
    text-align: right;
  }

  .tags {
    .tag {
      background: rgba(238, 238, 238, 1);
      border-radius: 2px;
      text-align: center;
      line-height: 26px;
      margin-right: 5px;
      font-size: 12px;
      padding: 0 5px;
    }
  }
}

.title {
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: #e50065;
    box-shadow: 0px 0px 16px 0px rgba(216, 216, 216, 0.79);
    margin-right: 5px;
    border-radius: 5px 0 5px 0;
  }
}
</style>
